/**
 * This barrel file provides the export for the shared NameListService.
 */
export * from "./util.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/util/index.ts